import api from '@/utils/api';

/**
 * Update company option
 * @param {string} companyId - Company Id
 * @returns {Promise}
 */
const getCompanyProductsApi = (companyId) => (query) => {
  const queryString = query ? `?${query}` : '';
  return api.get(`company/${companyId}/product${queryString}`);
};

export default getCompanyProductsApi;
